import { RoomlabelsApi } from '../api-clients';
import { wrap } from '../wrap';

export const roomlabelApi = {
  index: wrap(RoomlabelsApi, RoomlabelsApi.prototype.indexRoomLabel),
};
